/* ===============================
   FABRIC CANVAS LOADER
================================ */

function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}

/* ===============================
   CANVAS SETUP
   NOTE: cWidth/cHeight and the text position below (left/top on
   text1Page) are placeholder values. Once the real front-facing
   product photo (office_desk_calendar_background.jpg) is uploaded,
   these need a quick calibration pass so the name sits exactly on
   the gold nameplate - same process used for the moon products.
================================ */

var cWidth = 1536, cHeight = 1024,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2;

var loader = jQuery('#customLoader');

var loadedObject, wMark, svgMrk;

let starimage = document.querySelector("#stars_background");
let starBackground = new fabric.Image(starimage, {
  left: 0,
  top: 0,
  selectable: false
});
starBackground.scaleToWidth(cWidth);

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(starBackground);
starBackground.sendToBack();

showFabricCanvasLoader();

addModify(window['canvas2']);

let canvasInitialRenderDone = false;

function markCanvasReady() {
  if (canvasInitialRenderDone) return;
  canvasInitialRenderDone = true;
  hideFabricCanvasLoader();
}

/* ===============================
   MAIN INIT
================================ */

(function () {
  function initDeskCalendarCustomizer() {

    const canvas2 = window['canvas2'];

    /* ===============================
       TEXT 1 - NAME
       Measured directly from the gold nameplate's clean, full-width
       band (no notch) in office_desk_calendar_background.jpg:
       x 574-1368, y 525-755, center (971, 640).
    ================================ */

const NAME_MAX_WIDTH = 720;
const NAME_MAX_HEIGHT = 210;
const NAME_MAX_FONT = 84;
const NAME_MIN_FONT = 28;

function fitNameText(textObj, maxWidth, maxHeight) {
  maxHeight = maxHeight || NAME_MAX_HEIGHT;


  textObj.set({ scaleX: 1, scaleY: 1 });

  let fontSize = NAME_MAX_FONT;
  textObj.set("fontSize", fontSize);
  textObj.setCoords();
  while (textObj.height > maxHeight && fontSize > NAME_MIN_FONT) {
    fontSize -= 2;
    textObj.set("fontSize", fontSize);
    textObj.setCoords();
  }
  const actualWidth = (typeof textObj.calcTextWidth === "function")
    ? textObj.calcTextWidth()
    : textObj.width;
  const scale = Math.min(1, maxWidth / actualWidth, maxHeight / textObj.height);
  if (scale < 1) {
    textObj.set({ scaleX: scale, scaleY: scale });
    textObj.setCoords();
  }
}

window["text1Page"] = new fabric.Text("Dr. Ayaan Malik", {
  left: 971,
  top: 640,
  originX: "center",
  originY: "center",
  textAlign: "center",
  lineHeight: 1.1,
  fontSize: NAME_MAX_FONT,
  fontFamily: "Dancing Script",
  fill: "#2a1a05",
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

canvas2.add(window["text1Page"]);
fitNameText(window["text1Page"], NAME_MAX_WIDTH);

var fontName1 = window["text1Page"].fontFamily;
jQuery(".choose_font1").val("'" + fontName1 + "'").trigger("change");

    /* ===============================
       NAME INPUT + FONT HANDLING
    ================================ */

    const nameInput = document.getElementById("text_1");

    if (nameInput) {
      nameInput.addEventListener("focus", function () {
        if (window["text1Page"].text === "Dr. Ayaan Malik") {
          window["text1Page"].set("text", "");
          canvas2.renderAll();
        }
      });

            nameInput.addEventListener("input", function (e) {
        window["text1Page"].set({
          text: e.target.value,
          left: 971,
          originX: "center"
        });
        fitNameText(window["text1Page"], NAME_MAX_WIDTH);
        canvas2.renderAll();
      });
    }

    jQuery(document).on("change", ".fontFamily", function () {
      const value = this.value;
      const canvasId = jQuery(this).data("canvas");
            const objId = jQuery(this).data("obj");
      if (window[canvasId] && window[objId]) {
        window[objId].set("fontFamily", value.replace(/'/g, ""));
        if (objId === "text1Page") {
          fitNameText(window[objId], NAME_MAX_WIDTH);
        }
        window[canvasId].renderAll();
      }
    });

    /* ===============================
       BRAND WATERMARK (bottom-right)
    ================================ */

    window["text55Page"] = new fabric.Text("@tasweer.com.pk", {
      left: 1420,
      top: 985,
      fontSize: 15,
      fontFamily: "Baloo2",
      fill: "#fff",
      lockMovementX: true,
      lockMovementY: true,
      hasControls: false
    });

    canvas2.add(window["text55Page"]);

    canvas2.renderAll();
    markCanvasReady();

    /* ===============================
       DOWNLOAD / ADD TO CART
    ================================ */

    jQuery(document).on('click', '#download', function () {
      loader.removeClass('hidden');
      setTimeout(function () {
        resizeObjects(canvas2);

        const id = ['canvas2'];
        const canvas = canvas2;
        var size = 406;
        loadMark(id, canvas, size);
        size = 4000;
        removeMark(canvas, size);

        window['canvas2exported'] = canvas.toDataURL('image/png');

        var enterText = jQuery('.enter_text input').val();
        var textFont = jQuery('.choose_font1 option:selected').val();
        var additionalInfo = jQuery('.tShirtImg textarea').val();

        canvasBlock(canvas);

        fetch('//technology-architects.com/tasweer-modules/save_order.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            temp_image: window['canvas2t'],
            original_image: window['canvas2exported']
          })
        })
          .then(response => response.json())
          .then(data => {
            var previewId = data[0],
                extraImg1 = data[1];
            jQuery('#previewImg').val(previewId);
            jQuery('#preExtraImg').val(extraImg1);
            jQuery('#enterText').val(enterText);
            jQuery('#textFont').val(textFont);
            jQuery('#addInfo').val(additionalInfo);
            jQuery('.product-form__buttons .product-form__submit').trigger('click');
            loader.addClass('hidden');
          })
          .catch(error => console.error('Error uploading image:', error));
      }, 100);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDeskCalendarCustomizer);
  } else {
    initDeskCalendarCustomizer();
  }
})();

/* ===============================
   RESPONSIVE ZOOM / DISPLAY HELPERS
   (unchanged utility pattern used across all customizer products)
================================ */

function canvasMakeImg(canvas, zoom) {
  var newZoomLevel = zoom / cWidth;
  setZoomMask(canvas, newZoomLevel);
}

function canvasBlock(canvas) {
  var zoom = jQuery('.product__media-outer').width();
  var newZoomLevel = zoom / cWidth;
  setZoomMask(canvas, newZoomLevel);
}

function setZoomMask(canvas, newZoomLevel) {
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width: cWidth * newZoomLevel,
    height: cHeight * newZoomLevel
  });
  canvas.renderAll();

  var wrapperEl = canvas.wrapperEl;
  if (wrapperEl) {
    wrapperEl.style.marginLeft = "auto";
    wrapperEl.style.marginRight = "auto";
    wrapperEl.style.display = "block";
  }
}

function addModify(canvas) {
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;

  canvas.on('object:added', function (e) {
    canvas.renderAll();
  });

  canvas.on('object:modified', function (e) {
    canvas.renderAll();
  });
}

jQuery(window).on('resize', function () {
  canvasBlock(window['canvas2']);
});

jQuery(window).on('load', function () {
  canvasBlock(window['canvas2']);
});

/* ===============================
   EXPORT: keep design fully inside canvas bounds
   (same safe fit used across the moon products)
================================ */

function resizeObjects(canvas) {
  if (typeof starBackground !== 'undefined') starBackground.setCoords();
  if (window['text1Page']) window['text1Page'].setCoords();
  if (window['text55Page']) window['text55Page'].setCoords();

  canvas.renderAll();

  var designResiz = new fabric.Group([
    starBackground,
    window['text1Page'],
    window['text55Page']
  ].filter(Boolean));

  designResiz.set({
    left: halfWidth,
    top: halfHeight,
    originX: 'center',
    originY: 'center'
  });

  var designResizScale = Math.min(
    (cWidth - 20) / designResiz.width,
    (cHeight - 20) / designResiz.height
  );
  designResiz.scale(designResizScale);
  designResiz.setCoords();
  canvas.renderAll();
}

/* ===============================
   BRAND WATERMARK (shared "wm_collage_portrait" snippet)
================================ */

function loadMark(id, canvas, size) {
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function (objects, options) {
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas, size);
  window[id + 't'] = canvas.toDataURL('image/png');
}

function removeMark(canvas, size) {
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas, size);
}
